// dateUtils.js
import moment from "moment";

export function getFormattedDateTime() {
  const now = moment();
  const formattedDate = now.format("DD MMM YYYY");
  const formattedTime = now.format("HH:mm");
  return `${formattedDate} - ${formattedTime}`;
}
